// Dashboards is special-cased: navigating TO it skips the
// transition, navigating FROM it transitions — handled in useRouteTransition.
export const DASHBOARDS_GROUP = 'dashboards';

// A stable key for the "page" a route belongs to. The transition overlay fires
// only when this key changes:
//  - list, subset navigation (/item/:itemId(/subset/:subsetId)) and bare list
//    all share `:list` → list <-> item and subset tab switches do NOT transition
//  - the row detail view (/detail/:itemId(/subset/:subsetId)) is `:detail` →
//    list <-> detail and item <-> detail DO transition; row-to-row inside detail
//    does NOT (same `:detail`)
//  - form / filter / export are their own groups; dataset <-> dataset differs
//    by datasetId
export const getRouteTransitionGroup = (pathname: string): string => {
  if (pathname.replace(/\/$/, '').endsWith('/dashboards')) {
    return DASHBOARDS_GROUP;
  }

  const datasetMatch = pathname.match(/\/dataset\/([^/]+)/);

  if (!datasetMatch) {
    // Non-dataset pages (login, ...) keyed by full path.
    return pathname;
  }

  const datasetId = datasetMatch[1];

  if (pathname.includes('/form/')) {
    return `${datasetId}:form`;
  }
  if (pathname.includes('/filter')) {
    return `${datasetId}:filter`;
  }
  if (pathname.includes('/export/')) {
    return `${datasetId}:export`;
  }
  // Only the /detail/ row view is its own group. /item/... (subset navigation)
  // stays in `:list`, so list <-> item does not transition.
  if (pathname.includes('/detail/')) {
    return `${datasetId}:detail`;
  }

  return `${datasetId}:list`;
};
